import styled from '@emotion/styled';
import Button from '__components/Button';
import TableScrollContainer from '__components/Tables/ScrollContainer';
import { SizedCell, TextEllipsisWithTooltip } from '__components/Kizen/Table';
import { KizenTypography } from '__app/typography';
import type { ServiceAccount } from '@kizen/api/service-account';

export const StyledTableScrollContainer = styled(TableScrollContainer)`
  & .BodyForSync {
    flex-direction: column;
  }
`;

export const StyledAddButton = styled(Button)`
  && {
    margin: 0;
    margin-top: 3px;
    padding: 0;
    height: 12px;
  }
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  gap: 20px;
`;

export const StyledActionSizedCell = styled(SizedCell)`
  > div {
    display: flex;
    justify-content: flex-end;
  }
`;

const STATUS_COLORS: Record<ServiceAccount['status'] | 'suspended', string> = {
  active: 'var(--color-viz-cat-1-primary)',
  disabled: 'var(--color-viz-cat-3-primary)',
  suspended: 'var(--color-viz-cat-3-primary)',
};

export const StatusDot = styled.span<{ status: ServiceAccount['status'] }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ status }) =>
    STATUS_COLORS[status] ?? 'var(--color-border-medium-light)'};
  margin-right: 10px;
`;

export const StatusCell = styled(TextEllipsisWithTooltip)`
  display: inline;
`;

export const StyledAccountName = styled.span`
  max-width: 340px;
  display: inline-flex;
  font-size: inherit;
  line-height: inherit;
  & > span {
    font-weight: bold;
    font-size: inherit;
    line-height: inherit;
  }
`;

export const StyledDeletionNotice = styled(KizenTypography)`
  background-color: var(--color-feedback-info-bg);
  padding: 10px;
  margin-bottom: 20px;
`;
